import createIcon from '../../createIcon';

/**
 * @component @name GasMeter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgNEgxNVYySDEzVjRIMTFWMkg5VjRIOEM1Ljc5IDQgNCA1Ljc5IDQgOFYxOEM0IDIwLjIxIDUuNzkgMjIgOCAyMkgxNkMxOC4yMSAyMiAyMCAyMC4yMSAyMCAxOFY4QzIwIDUuNzkgMTguMjEgNCAxNiA0Wk0xMiAxOEMxMC42MiAxOCA5LjUgMTYuOSA5LjUgMTUuNTRDOS41IDE0LjQ1IDkuOTMgMTQuMTUgMTIgMTEuNzVDMTQuMDUgMTQuMTMgMTQuNSAxNC40NSAxNC41IDE1LjU0QzE0LjUgMTYuOSAxMy4zOCAxOCAxMiAxOFpNMTYgMTBIOFY4SDE2VjEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GasMeter = createIcon('GasMeter', [
  [
    'path',
    {
      d: 'M16 4H15V2H13V4H11V2H9V4H8C5.79 4 4 5.79 4 8V18C4 20.21 5.79 22 8 22H16C18.21 22 20 20.21 20 18V8C20 5.79 18.21 4 16 4ZM12 18C10.62 18 9.5 16.9 9.5 15.54C9.5 14.45 9.93 14.15 12 11.75C14.05 14.13 14.5 14.45 14.5 15.54C14.5 16.9 13.38 18 12 18ZM16 10H8V8H16V10Z',
      key: '11fkgl',
    },
  ],
]);

export default GasMeter;
